
import { Component, Vue } from "vue-property-decorator";
import { Configuration } from "../models/appConfig";

@Component
export default class Footer extends Vue {
  private issuerName = "";

  created() {
    const appConfig = this.$store.getters[
      "configuration/getConfiguration"
    ] as Configuration;
    this.issuerName = appConfig.app.issuer.name;
  }
}
